import React, { Fragment} from 'react';

// TODO: find a way to lazy-load modules and still make transitions work (right now suspense components will break Transitions and cause them to flicker)

import Collection from './Collection';
import Image from './Image';
import Stage from './Stage';
import Text from './Text';
import Video from './Video';

String.prototype.capitalize = function() {
  return this.charAt(0).toUpperCase() + this.slice(1)
}

const modules = {
  'Collection': Collection,
  'Image': Image,
  'Stage': Stage,
  'Text': Text,
  'Video': Video,
}

export default props => {
  return (
    <div className="modules">
      <Fragment>
        {props.modules.map((module, i) => {
          const { acf_fc_layout, ...moduleProps } = module;
          const moduleName = acf_fc_layout.capitalize();

          return React.createElement(modules[moduleName], {
            key: `module-${i}`,
            ...moduleProps
          });
        })}
      </Fragment>
    </div>
  )
}
